import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { TabStateService } from '../../../core/services/tab-state.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.css',
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  currentRoute: string = '';
  activeTab: 'sign' | 'verify' = 'sign';

  constructor(
    private router: Router,
    private tabStateService: TabStateService
  ) {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.urlAfterRedirects || event.url;
      });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.currentRoute = this.router.url;
    }, 0);

    this.tabStateService.activeTab
      .pipe(takeUntil(this.destroy$))
      .subscribe(tab => {
        this.activeTab = tab;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goToCanalVentas(): void {
    window.open(environment.canalVentas, '_blank');
  }

  goToSign(): void {
    this.router.navigate(['/']);
    this.tabStateService.setActiveTab('sign');
  }

  goToVerify(): void {
    this.router.navigate(['/']);
    this.tabStateService.setActiveTab('verify');
  }

  isSignActive(): boolean {
    return this.activeTab === 'sign';
  }

  isVerifyActive(): boolean {
    return this.activeTab === 'verify';
  }
}
